<!-- 
Expander panel showing the financial strength calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelFinancialStrengthScore)"
    >
      <v-icon class="sub-breakdown">subdirectory_arrow_right</v-icon>
      Risk factor value: Financial strength
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.FinancialStrengthScore"/>
        <v-card-text class="pt-2 px-0 pb-0">
          <v-layout row wrap mx-4>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field v-if="showFinancialStrengthSubScores" label-width="11">
                <template slot="label">
                  <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelNetProfitRatioScore)">
                    Net profit ratio score
                  </a>
                  + 
                  <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelReturnOnAssetsScore)">
                    Return on assets score
                  </a>
                  + 
                  <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelDebtToEquityScore)">
                    Debt to equity score
                  </a>
                </template>
                {{ levyCalculation.netProfitRatioScore | numericInput2 }} + 
                {{ levyCalculation.returnOnAssetsScore | numericInput2 }} + 
                {{ levyCalculation.debtToEquityScore | numericInput2 }}
                =
                {{ totalOfSubScores | numericInput2 }}
              </our-data-field>
              <our-data-field v-else label="Financial strength score" label-width="11">
                0 (no financial statement supplied)
              </our-data-field>
            </v-flex>
            <v-flex xs12 sm4 pb-4>
              <risk-factor-table
                :estimator-key="estimatorKey" 
                :levy-collection-id="levyCollection.id" 
                :selected-score="levyCalculation.financialStrengthScore" 
                is-percentage 
                type="FinancialStrength" 
                title="Financial strength score"
              />
            </v-flex>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Financial strength risk factor value" typography="title" label-width="11">
                {{ levyCalculation.financialStrengthScore | numericInput2 }}
                <template v-slot:footer>
                  <playground-up-down v-if="isLevyEstimator" field="financialStrengthScore" show-original small/>
                </template>
              </our-data-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import RiskFactorTable from "@/components/levy-collection-providers/calculation/RiskFactorTable.vue";

export default {
  components: {
    PlaygroundUpDown,
    RiskFactorTable
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    totalOfSubScores() {
      return (
        this.levyCalculation.netProfitRatioScore +
        this.levyCalculation.returnOnAssetsScore +
        this.levyCalculation.debtToEquityScore
      );
    }
  }
};
</script>
